





















































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import MainComponent from "@/components/layout/MainComponent.vue";
import SidebarComponent from "@/components/layout/SidebarComponent.vue";
import ContentComponent from "@/components/layout/ContentComponent.vue";
import SidebarContentHeaderComponent from "@/components/layout/SidebarContentHeaderComponent.vue";
import MenubarComponent from "@/components/layout/MenubarComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import SensorMenuModalComponent from "./SensorMenuModalComponent.vue";
import ConfirmDialogComponent from "@/components/common/parts/ConfirmDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import {
  getDiagramApi,
  postDiagramApi
} from "@/typescript/api_client/emesh_api/stores/diagram_api";
import { postStoresDiagramApi } from "@/typescript/api_client/emesh_api/stores/stores_diagram_api";
import { storeMenus } from "@/config/store_menus";
import { getRoutePath } from "@/router/routes";

@Component({
  components: {
    HeaderComponent,
    MainComponent,
    SidebarComponent,
    ContentComponent,
    SidebarContentHeaderComponent,
    MenubarComponent,
    ButtonComponent,
    SensorMenuModalComponent,
    ConfirmDialogComponent,
    FooterComponent
  }
})
export default class SensorDefaultSettingPage extends Vue {
  $refs!: {
    diagram_file: any;
  };

  isConfirmDialogOpen: boolean = false;

  // ドラッグ＆ドロップのドラッグ中の見た目変更用
  isDrag: boolean = false;

  created() {
    this.$store.commit("setActiveId", {
      activeId: storeMenus().find(m => m.pageName === "MasterManagementsPage")
        ?.id
    });
  }

  save() {
    const path = getRoutePath("MasterManagementsPage", {
      store_id: this.$route.params.store_id
    });
    this.$router.push(path);
  }

  selectFile() {
    this.$refs.diagram_file.click();
  }

  uploadReflect() {
    const storeId = this.$route.params.store_id;
    const file = this.$refs.diagram_file.files[0];
    postDiagramApi(storeId, file).then(() => {
      // @TODO: API から diagram_id が返却されるようになれば、getDiagramApi の呼び出しは不要
      getDiagramApi(storeId).then(resp => {
        const diagramId = resp.slice(-1)[0].diagram_id;
        postStoresDiagramApi(storeId, diagramId).then(() => {
          this.$router.push({
            path: getRoutePath("SensorDiagramsEditPage", {
              store_id: storeId
            }),
            query: { diagram_id: String(diagramId) }
          });
          this.$router.go({ path: this.$router.currentRoute.path } as any);
        });
      });
    });
  }

  handleDrop(event) {
    this.isDrag = false;
    const files = event.target.files || event.dataTransfer.files;
    this.$refs.diagram_file.files = files;
    this.uploadReflect();
    event.target.value = null;
  }

  openDialog() {
    this.isConfirmDialogOpen = true;
  }

  closeConfirm() {
    this.isConfirmDialogOpen = false;
  }

  movePage() {
    this.$router.push(
      getRoutePath("MasterManagementsPage", {
        store_id: this.$route.params.store_id
      })
    );
  }

  handleDrag(isDrag) {
    this.isDrag = isDrag;
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }
}
